import { Injectable } from '@angular/core';
import {TechnicalApplicationSelectImageComponent} from './technical-application-select-image/technical-application-select-image.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ImageService} from '../api/image.service';
import {ProgressService} from '../controls/progress.service';
import {FilterStorageService} from '../services/filter-storage.service';
import {ImageModel} from '../api/image-model';

@Injectable({
  providedIn: 'root'
})
export class IconService {

  constructor(
    private modalService: NgbModal,
    private progress: ProgressService,
    private filters: FilterStorageService,
    private images: ImageService
  ) { }

  async selectImage(): Promise<ImageModel> {
    const modalRef = this.modalService.open(TechnicalApplicationSelectImageComponent);
    const component: TechnicalApplicationSelectImageComponent = modalRef.componentInstance;

    try {
      this.progress.show();

      const images = await this.images.getIcons(this.filters.getSelectedOrganization().id).toPromise();
      component.imageList = images.data;
    } finally {
      this.progress.hide();
    }

    const result = await modalRef.result;

    if (result === 0) { return null; }

    return result;
  }
}
